import { EuiBadge, euiPaletteColorBlind } from "@inscopix/ideas-eui";

export const getTagColor = (tag: string) => {
  const colors = euiPaletteColorBlind({ rotations: 6 });
  return colors[Math.floor(tag.length % colors.length)];
};

interface TagProps {
  tag: string;
}

export const Tag = ({ tag }: TagProps) => {
  return (
    <EuiBadge iconType="tag" color={getTagColor(tag)}>
      {tag}
    </EuiBadge>
  );
};
